<template></template>

<script>
export default {
	components: {},
	data() {
		return {};
	},
	props: {
		isMobile: Boolean,
		formID: String,
	},
	methods: {},
};
</script>

<style scoped>

</style>
